import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipIssInfo = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    “Padrão” é exibido porque a alíquota de ISS não foi preenchida manualmente nas Configurações Fiscais dentro do Produttivo. 
                    Nesse caso, o valor será definido automaticamente pelo portal de emissão e será exibido na nota fiscal emitida.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipIssInfo;